import styled from 'styled-components'

import { H4 } from 'components/Typography'
import { CommonButton } from 'components/Button'

export const AuditHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`

export const AuditHeaderTitle = styled(H4)``

export const AuditCheckForNewLogsButton = styled(CommonButton)`
  display: flex;
  text-transform: capitalize;
  background: transparent;
  font-weight: 900;
  height: 40px;
`
